(() => {
  'use strict';
  if (window.__printoraProductImageSync) return;
  window.__printoraProductImageSync = true;

  /* Inject sync CSS so cached product HTML still gets collection-style fades */
  (function injectSyncCss() {
    if (document.getElementById('printora-pdp-img-sync-css')) return;
    const style = document.createElement('style');
    style.id = 'printora-pdp-img-sync-css';
    style.textContent = `
      html.pv2-img-syncing body.template-product .pv2-square-tile img,
      html.pv2-img-syncing body.template-product .pv2-colour-card img,
      html.pv2-img-syncing body.template-product .pv2-colour-photo-expand img,
      html.pv2-img-syncing body.template-product .productView-image img,
      html.pv2-img-syncing body.template-product .product-form__swatch .pv2-colour-photo-label img,
      html.pv2-img-syncing body.template-product .product-form__swatch .pattern.pv2-colour-photo {
        opacity: 0.12 !important;
        transition: none !important;
      }
      html.pv2-img-ready body.template-product .pv2-square-tile img,
      html.pv2-img-ready body.template-product .pv2-colour-card img,
      html.pv2-img-ready body.template-product .pv2-colour-photo-expand img,
      html.pv2-img-ready body.template-product .productView-image img,
      html.pv2-img-ready body.template-product .product-form__swatch .pv2-colour-photo-label img,
      html.pv2-img-ready body.template-product .product-form__swatch .pattern.pv2-colour-photo {
        opacity: 1 !important;
        transition: opacity 0.35s ease !important;
      }
      body.template-product .pv2-square-tile,
      body.template-product .pv2-square-tile img,
      body.template-product .productView-image,
      body.template-product .productView-image img {
        background: #fff !important;
      }
    `;
    (document.head || document.documentElement).appendChild(style);
  })();

  const SELECTOR = [
    '.pv2-square-tile:not(.is-colour-hidden):not([hidden]) img:not(.pv2-img-deferred)',
    '.pv2-colour-card.has-image img',
    '.pv2-colour-photo-expand img',
    '.productView-nav .productView-image img',
    '.productView-images-wrapper .productView-image img'
  ].join(',');

  function visibleImages() {
    return [...document.querySelectorAll(SELECTOR)].filter((img) => {
      if (!img || !img.getAttribute('src')) return false;
      if (img.classList.contains('pv2-img-deferred')) return false;
      const src = img.currentSrc || img.src || '';
      if (!src || src.startsWith('data:')) return false;
      const tile = img.closest('.pv2-square-tile, .productView-image, .pv2-colour-card, label');
      if (tile && (tile.hidden || tile.getAttribute('aria-hidden') === 'true')) return false;
      return true;
    });
  }

  function whenLoaded(img) {
    if (img.complete && img.naturalWidth > 0) return Promise.resolve();
    return new Promise((resolve) => {
      const done = () => resolve();
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      if (typeof img.decode === 'function') {
        img.decode().then(done).catch(done);
      }
    });
  }

  function finish() {
    const root = document.documentElement;
    if (root.classList.contains('pv2-img-ready')) return;
    root.classList.remove('pv2-img-syncing');
    root.classList.add('pv2-img-ready');
    window.dispatchEvent(new CustomEvent('pv2:imagesready'));
  }

  function startSync() {
    const root = document.documentElement;
    if (root.classList.contains('pv2-img-ready')) return;

    root.classList.add('pv2-img-syncing');
    root.classList.remove('pv2-img-ready');

    const imgs = visibleImages().slice(0, 8);
    if (!imgs.length) {
      window.setTimeout(finish, 40);
      return;
    }

    const loaded = Promise.all(imgs.map(whenLoaded));
    const timeout = new Promise((resolve) => window.setTimeout(resolve, 750));

    Promise.race([loaded, timeout]).then(() => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(finish);
      });
    });
  }

  window.__pv2StartImageSync = startSync;

  function boot() {
    const root = document.documentElement;
    if (root.classList.contains('pv2-hold-ready') || root.classList.contains('pv2-product-revealed') || document.querySelector('.productView')) {
      startSync();
      return;
    }
    const prev = window.__pv2RevealProductPaint;
    window.__pv2RevealProductPaint = function patchedReveal() {
      try { if (typeof prev === 'function') prev(); } catch (e) {}
      root.classList.add('pv2-img-syncing');
      startSync();
    };
    try {
      const obs = new MutationObserver(() => {
        if (root.classList.contains('pv2-hold-ready') || document.querySelector('.productView')) {
          obs.disconnect();
          startSync();
        }
      });
      obs.observe(root, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      window.setTimeout(() => { try { obs.disconnect(); } catch (e) {} startSync(); }, 1200);
    } catch (e) {
      window.setTimeout(startSync, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', () => {
    document.documentElement.classList.remove('pv2-img-ready');
    startSync();
  });
})();
